<template>
<div>
  <div style="width: calc(100vw - 450px);">
    <el-descriptions :column="2" border size="mini" :label-style="{width: '100px'}">
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
          <el-option
            v-for="item in meter_type_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="当前房产">
        <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准">
        <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable placeholder="收费标准" class="kuan">
          <el-option
            v-for="item in house_charge_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="仪表状态">
        <el-checkbox-group v-model="where.status_ids">
          <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="仪表性质">
        <el-checkbox-group v-model="where.meter_nature_ids">
          <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入收费对象" v-model="where.name" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-checkbox-group v-model="where.energy_ids">
          <el-checkbox v-for="(item,index) in energy_list" :label="item.val" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="下载操作">
        <el-button size="mini" type="primary" @click="dowExcel()" style="margin-right: 5px;">下载模板</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="上传操作">
        <el-button size="mini" type="primary" @click="uploadExcel()" style="margin-right: 5px;">上传模板</el-button>
      </el-descriptions-item>
    </el-descriptions>
  </div>

</div>
</template>

<script>
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterAmountTagImport",
  components: { },
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data () {
    return {
      loading: false,
      where:{
        meter_type: "",
        house_name: "",
        project_id:"",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        energy_ids:[2,3],
        name: "",
        meter_virtually:[1]
      },
      excel_list:[],
      dialogVisible:false,
      house_charge_list:[],
      meter_type_list: [],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  mounted() {
    this.where.project_id = this.mainObj.project_id;
    this.getMeterTypeList()
    this.where.house_name=this.mainObj.house_name;
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "where.project_id":function (n) {
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      that.where.project_id = that.mainObj.project_id;
      that.where.house_name=that.mainObj.house_name;
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
  },
  methods: {
    importExcel(excel_file) {
      const that = this;

      MeterHttp.post("Meter/importMeterAmountTag?user_type="+(that.$route.query.type||0),{
        project_id: that.mainObj.project_id,
        file: excel_file,
      }, res => {
        if(res.code) {
          that.$message.success('Excel表单导入成功');
        }else {
          that.$message.error('Excel表单导入失败');
        }
        that.loading=false;
      });

    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.where.project_id = data.tree[0].pindex_id;
      this.where.house_name=tree_str;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        field: "id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.where.project_id&&(where.pindex_id=this.where.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      MeterHttp.get("HouseCharge/getList",{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    dowExcel(){
      if(this.where.house_name == ''){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      var that=this;
      let where=reObject(that.where);
      ERP.showLoading()
      MeterHttp.post("Meter/exportMeterAmountTag?user_type="+(that.$route.query.type||0),{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type: (that.$route.query.type || 0),
      },ret=>{
        ERP.hideLoading()
        if(ret.code){
          if(ret.data.indexOf("http")===-1){
            window.open(__HTTP__.defaults.baseURL +ret.data)
          }else {
            window.open(ret.data)
          }
        }
      })
    },
    tableRowClassName({row, rowIndex}) {
      const that=this;
      if (row.is_repeated) {
        return 'warning-row';
      }else if (row.is_project) {
        return 'project-row';
      }else if (row.is_not_architecture) {
        return 'architecture-row';
      }else {
        return "success-row"
      }
    },
    uploadExcel(){
      const that=this;
      MeterHttp.uploadFile(file=>{
        that.importExcel(file)
      })
    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../common";
.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
.table-wrap2{
  >>>.warning-row{
    background-color: rgba(255, 61, 0, 0.19);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
  >>>.project-row{
    background-color: rgba(255, 174, 0, 0.19);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
  >>>.architecture-row{
    background-color: rgba(156, 74, 169, 0.34);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterAmountTagImport.vue